import { isNilOrEmpty } from './objectUtils';
import { Language } from './types';

export const flattenMessages = (
  nestedMessages: Record<string, string | unknown>,
  prefix: string = ''
): Record<string, string> =>
  Object.keys(nestedMessages).reduce(
    (messages, key) => {
      const value = nestedMessages[key];
      const prefixedKey = prefix ? `${prefix}.${key}` : key;

      if (typeof value === 'string') {
        messages[prefixedKey] = value; // eslint-disable-line
      } else {
        Object.assign(messages, flattenMessages(value as Record<string, string | unknown>, prefixedKey));
      }

      return messages;
    },
    {} as Record<string, string>
  );

export const getTypedLanguage = (language?: Language | string | null) => {
  if (isNilOrEmpty(language)) {
    return Language.EN;
  }
  if (!(typeof language === 'string')) {
    return language as Language;
  }
  if (Object.values(Language).includes(language.toUpperCase() as unknown as Language)) {
    return language.toUpperCase() as unknown as Language;
  }
  throw new Error(`${language} is not an Up2Rent language`);
};
